import axios from "axios";
import * as React from "react";
import { Input } from "@neworbit/simpleui-input";
import { Loader } from "semantic-ui-react";

import { CustomerSraDepartment } from "@teamprevent/common/customerSraDepartment/model";

import { CustomerSraDepartmentsApi } from "../../customerSraDepartments/CustomerSraDepartmentsApi";

interface Props {
    selectedDepartmentId: string;
    onDepartmentSelected: (departmentId: string) => void;
}

const AllDepartmentsOption = "All";

const DepartmentFilter: React.FunctionComponent<Props> = (props) => {
    const [departments, setDepartments] = React.useState<CustomerSraDepartment[]>();

    React.useEffect(() => {
        (async () => {
            const apiResponse = await (new CustomerSraDepartmentsApi(axios)).load();
            setDepartments(apiResponse);
        })();
    }, []);

    const onDepartmentSelected = (departmentId: string) => {
        props.onDepartmentSelected(departmentId);
    };

    if (!departments) {
        return <Loader active />;
    }

    return (
        <Input.Dropdown
            value={props.selectedDepartmentId}
            options={[{ value: AllDepartmentsOption, text: "All Departments" }, ...departments.map(d => ({ value: d.id, text: d.name }))]}
            onChange={onDepartmentSelected}
            dynamicOptions
        />
    );
};

export { DepartmentFilter, AllDepartmentsOption };
